import React from 'react'
import { graphql } from 'react-apollo'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import { Paper, Typography, Modal } from 'material-ui'
import TextField from 'material-ui/TextField'
import GridList, { GridListTile } from 'material-ui/GridList'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import { GC_USER_ID, GC_AUTH_TOKEN, ALABASTER } from '@/constants'
import BookIcon from 'material-ui-icons/Book'
import AddIcon from 'material-ui-icons/Add'
import DescriptionIcon from 'material-ui-icons/Description'
import * as moment from 'moment'

import { READ_USERNAME } from '@/graphql/queries/user'
import { CREATE_DATASET, UPDATE_DATASET } from '@/graphql/mutations/dataset'
import {
  READ_DATASETNAMEDES,
  READ_DATASETNAME
} from '@/graphql/queries/dataset'

const styles = theme => ({
  root: {
    width: '100%'
  },
  activeSection: {
    backgroundColor: 'white',
    padding: 50
  },
  diableSection: {
    backgroundColor: '#f8f8f8',
    padding: 50
  },
  addSection: {
    backgroundColor: ALABASTER,
    padding: 25
  },
  gridList: {
    width: '100%'
  },
  GridListTile: {
    height: 80
  },
  paperBlockAdd: {
    margin: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'white',
    height: 72,
    width: 72,
    cursor: 'pointer'
  },
  paperBlock: {
    position: 'relative',
    margin: theme.spacing.unit * 1,
    height: 72,
    width: 72,
    cursor: 'pointer'
  },
  bookBlock: {
    position: 'relative',
    textAlign: 'center',
    boxShadow: '0px 0px 10px #eeeeee',
    backgroundColor: 'rgba(80, 227, 194, .1)',
    width: 72,
    height: 72
  },
  bookBlockChecked: {
    textAlign: 'center',
    boxShadow: '0px 0px 10px #eeeeee',
    backgroundImage:
      'linear-gradient(to bottom, rgba(80, 227, 194, .8) 0%, #ffffff 80%)',
    width: 72,
    height: 72,
    position: 'absolute',
    top: 0,
    left: 0
  },
  bookBlockAdd: {
    position: 'relative',
    textAlign: 'center',
    width: 72
  },
  iconBookAdd: {
    color: 'rgba(0, 0, 0, .1)',
    width: 40,
    height: 40
  },
  iconBook: {
    color: 'rgba(0, 0, 0, .1)',
    width: 40,
    height: 40
  }
})

var activeTrackers = []

@withApollo
@inject('resultTrackers')
@inject('resultTrackerPref')
@observer
@graphql(CREATE_DATASET, { name: 'createDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_USERNAME, {
  name: 'ReadUserName',
  options: ({ match }) => ({
    variables: {
      userID: global.localStorage.getItem(GC_USER_ID)
        ? global.localStorage.getItem(GC_USER_ID)
        : 'NA'
    }
  })
})
@graphql(READ_DATASETNAMEDES, {
  name: 'readAlchemyTrackerListDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultAlchemyTrackerListSharedToPublic',
      dataDescription: 'defaultAlchemyTrackerListSharedToPublic'
    }
  })
})
@graphql(READ_DATASETNAME, {
  name: 'readUserTrackerPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultUserTrackerPreference',
      userId: global.localStorage.getItem(GC_USER_ID)
        ? global.localStorage.getItem(GC_USER_ID)
        : 'NA'
    }
  })
})
@withStyles(styles)
export default class UserPreference extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      activeTrackers: [],
      time: 0,
      trackPrefDatasetId: '',
      trackerListDatasetId: ''
    }

    this.handleAddTracker = this.handleAddTracker.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.chooseTracker = this.chooseTracker.bind(this)
  }

  handleClose = () => {
    // add to database
    if (!this.props.resultTrackerPref.activeTrackers) {
      this.props.resultTrackerPref.tabSelected = 'add'
    } else if (this.props.resultTrackerPref.activeTrackers.length === 0) {
      this.props.resultTrackerPref.tabSelected = 'add'
    }
    this.props.history.push(`/`)
  }

  chooseTracker = tracker => {
    var allTrackersPref = this.props.resultTrackerPref.trackers
    const trackerSelected = {
      id: tracker.id,
      name: tracker.name,
      description: tracker.description,
      img: '/cloud_done.png',
      isActive: '1'
    }
    // get or create user tracker preference
    if (this.props.readUserTrackerPreference.loading) {
      return <div>Loading user tracker preference data ... </div>
    }

    // check if tracker exists in preference
    const trackerSelectedBefore = allTrackersPref.filter(
      t => t.id === tracker.id
    )
    if (trackerSelectedBefore.length === 0) {
      //add tracker to preference
      allTrackersPref.splice(0, 0, trackerSelected)
      this.props.resultTrackerPref.updateTrackers(allTrackersPref)
    } else if (trackerSelectedBefore.length === 1) {
      //reset isactive
      if (trackerSelectedBefore[0].isActive === '0') {
        trackerSelected.isActive = '1'
      } else if (trackerSelectedBefore[0].isActive === '1') {
        trackerSelected.isActive = '0'
      }
      //update tracker to prefence
      this.props.resultTrackerPref.updateUserTrackerPreference(
        trackerSelected.id,
        trackerSelected.isActive
      )
    }
    this.props.resultTrackerPref.updateTrackersActiveFromAll()
    this.setState({
      activeTrackers: this.props.resultTrackerPref.trackersActive
    })
    activeTrackers = this.props.resultTrackerPref.trackersActive
    //update to dataset
    this.updateDataPointsUserTrackerPref(
      JSON.stringify(this.props.resultTrackerPref.trackers)
    )
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
    this.props.resultTrackers.tracker[name] = event.target.value
  }

  updateDataPointsUserTrackerPref = async dataPoints => {
    if (this.props.readUserTrackerPreference.allDataSets.length === 0) {
      if (this.state.trackPrefDatasetId === '') {
        return <div>readUserTrackerPreference is not created </div>
      }

      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.state.trackPrefDatasetId,
          dataPoints: dataPoints
        },
        update: () => {
          //('Tracker preference data updated: readUserTrackerPreference')
        }
      })
    } else {
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.readUserTrackerPreference.allDataSets[0].id,
          dataPoints: dataPoints
        },
        update: () => {
          //('Tracker preference data updated: readUserTrackerPreference')
        }
      })
    }
  }

  createDataSet = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      // this.props.history.push(`/login`)
      console.log('not logged in')
      return
    }
    // if default table is there, refuse to create
    if (this.props.readAlchemyTrackerListDefault.allDataSets.length > 0) {
      //('there is already default tracker list there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultAlchemyTrackerListSharedToPublic',
        description: 'defaultAlchemyTrackerListSharedToPublic',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        //('default tracker list created')
        this.setState({ trackerListDatasetId: createDataSet.id })
      }
    })
  }

  createDataSetUserTrackerPref = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      // this.props.history.push(`/login`)
      console.log('not logged in')
      return
    }
    // if default table is there, refuse to create
    if (this.props.readUserTrackerPreference.allDataSets.length > 0) {
      console.log('there is already default user book preference table there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultUserTrackerPreference',
        description: 'defaultUserTrackerPreference',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        console.log('default user tracker preference table created')
        this.setState({ trackPrefDatasetId: createDataSet.id })
      }
    })
  }

  handleAddTracker = () => {
    //('adding new tracker')
    const num =
      this.props.resultTrackers.trackers.length === 0
        ? 1
        : this.props.resultTrackers.trackers[0].id + 1
    const newTracker = {
      id: num,
      name: '',
      description: '',
      img: '/cloud_done.png',
      addedBy: global.localStorage.getItem(GC_USER_ID),
      addedAt: moment().format()
    }
    var allTrackers = this.props.resultTrackers.trackers
    allTrackers.splice(0, 0, newTracker)
    this.props.resultTrackers.updateTrackers(allTrackers)
    this.props.resultTrackers.updateTracker(newTracker)
    this.setState({ open: true })
  }

  handleCloseAddTrackerNo = () => {
    if (this.props.readAlchemyTrackerListDefault.allDataSets.length === 1) {
      if (
        this.props.readAlchemyTrackerListDefault.allDataSets[0].dataPoints !==
        ''
      ) {
        //('defualt tracker list is refreshed.')
        this.props.resultTrackers.updateTrackers(
          JSON.parse(
            this.props.readAlchemyTrackerListDefault.allDataSets[0].dataPoints
          )
        )
      }
    }
    this.setState({ open: false })
  }

  handleCloseAddTrackerYes = () => {
    this.props.resultTrackers.trackers[0] = this.props.resultTrackers.tracker
    this.updateDataPoints(JSON.stringify(this.props.resultTrackers.trackers))
    this.chooseTracker(this.props.resultTrackers.tracker)
    this.setState({ open: false })
  }

  updateDataPoints = async dataPoints => {
    if (this.props.readAlchemyTrackerListDefault.allDataSets.length === 0) {
      if (this.state.trackerListDatasetId === '') {
        return <div>readAlchemyTrackerListDefault is not created </div>
      }

      try {
        await this.props.UpdateDataSet({
          variables: {
            datasetId: this.state.trackerListDatasetId,
            dataPoints: dataPoints
          },
          update: () => {
            //('Tracker data updated')
          }
        })
      } catch (e) {
        console.log('There is an error: ' + e)
        // todo: add data refresher to re-read database and give to result store
        this.signOut()
      }
    } else {
      try {
        await this.props.UpdateDataSet({
          variables: {
            datasetId: this.props.readAlchemyTrackerListDefault.allDataSets[0]
              .id,
            dataPoints: dataPoints
          },
          update: () => {
            //('Tracker data updated')
          }
        })
      } catch (e) {
        console.log('There is an error: ' + e)
        // todo: add data refresher to re-read database and give to result store
        this.signOut()
      }
    }
  }

  signOut = () => {
    global.localStorage.removeItem(GC_USER_ID)
    global.localStorage.removeItem(GC_AUTH_TOKEN)
    this.props.history.push(`/login`)
  }

  componentWillMount() {
    //user login redirect
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/register`)
    }
  }

  render() {
    const { classes } = this.props
    const userId = global.localStorage.getItem(GC_USER_ID)
    var userName = ''
    var allTrackerPref = []

    // get user name
    if (userId) {
      if (this.props.ReadUserName && this.props.ReadUserName.loading) {
        return <div>Loading</div>
      }

      if (this.props.ReadUserName && this.props.ReadUserName.error) {
        return <div>Error: {this.props.ReadUserName.error}</div>
      }
      userName = this.props.ReadUserName.User.name
    }

    //get or create tracker list
    if (this.props.readAlchemyTrackerListDefault.loading) {
      return <div>Loading tracker data ... </div>
    }

    if (
      this.props.readAlchemyTrackerListDefault &&
      this.props.readAlchemyTrackerListDefault.error
    ) {
      return <div>Error: readAlchemyTrackerListDefault</div>
    }

    if (
      this.props.resultTrackers.trackers.length === 0 &&
      !this.props.resultTrackers.created
    ) {
      if (this.props.readAlchemyTrackerListDefault.allDataSets.length === 1) {
        if (
          this.props.readAlchemyTrackerListDefault.allDataSets[0].dataPoints !==
          ''
        ) {
          //('defualt tracker table is there.')
          this.props.resultTrackers.updateTrackers(
            JSON.parse(
              this.props.readAlchemyTrackerListDefault.allDataSets[0].dataPoints
            )
          )
        }
      } else if (
        this.props.readAlchemyTrackerListDefault.allDataSets.length === 0
      ) {
        //('defualt tracker table to be added')
        this.createDataSet(JSON.stringify(this.props.resultTrackers.trackers))
        this.props.resultTrackers.updateCreated()
      } else {
        return (
          <div>
            Error, please contact our support team
            [readAlchemyTrackerListDefault:{' '}
            {this.props.readAlchemyTrackerListDefault.allDataSets.length}]
          </div>
        )
      }
    }

    // get or create user tracker preference
    if (this.props.readUserTrackerPreference.loading) {
      return <div>Loading user tracker preference data ... </div>
    }

    if (this.props.resultTrackerPref.trackers.length === 0) {
      if (this.props.readUserTrackerPreference.allDataSets.length === 1) {
        if (
          this.props.readUserTrackerPreference.allDataSets[0].dataPoints !== ''
        ) {
          allTrackerPref = JSON.parse(
            this.props.readUserTrackerPreference.allDataSets[0].dataPoints
          )
          this.props.resultTrackerPref.updateTrackers(allTrackerPref)
          this.props.resultTrackerPref.updateTrackersActiveFromAll()
        }
      } else if (
        this.props.readUserTrackerPreference.allDataSets.length === 0
      ) {
        if (!this.props.resultTrackerPref.created) {
          //('create defaultUserTrackerPreference table')
          this.createDataSetUserTrackerPref(JSON.stringify(allTrackerPref))
          this.props.resultTrackerPref.updateCreated()
        }
      } else {
        return (
          <div>
            Error, please contact our support team [resultTrackerPref:{' '}
            {this.props.readUserTrackerPreference.allDataSets.length}]
          </div>
        )
      }
    }

    activeTrackers = this.props.resultTrackerPref.trackersActive

    return (
      <div className={classes.root}>
        <Paper
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
            textAlign: 'center'
          }}
        >
          <List>
            <ListItem divider>
              <ListItemText
                className={classes.modalHealder}
                primary={
                  <Typography
                    variant="body1"
                    style={{ fontSize: 18, color: 'grey', paddingLeft: 10 }}
                  >
                    Hi {userName ? userName : 'there'}, what would you like to
                    track?
                  </Typography>
                }
              />
              <IconButton
                color="inherit"
                aria-label="Back"
                onClick={this.handleClose}
              >
                <ChevronRightIcon style={{ color: 'grey' }} />
              </IconButton>
            </ListItem>
            <ListItem className={classes.activeSection}>
              <GridList className={classes.gridList} cols={3}>
                <GridListTile xs={6} cols={1} key={'addnewtracker'}>
                  <Paper
                    className={classes.paperBlockAdd}
                    onClick={this.handleAddTracker}
                  >
                    <div id="bookblockAdd" className={classes.bookBlockAdd}>
                      <AddIcon className={classes.iconBookAdd} />
                    </div>
                    <Typography
                      variant="body1"
                      id="bookName"
                      style={{
                        paddingLeft: 2,
                        paddingRight: 2,
                        textAlign: 'center',
                        fontSize: 12,
                        color: 'grey',
                        lineHeight: 1.1
                      }}
                    >
                      Add New Tracker
                    </Typography>
                  </Paper>
                </GridListTile>
                {this.props.resultTrackers.trackers.map(tk => (
                  <GridListTile
                    xs={6}
                    cols={1}
                    key={tk.id}
                    className={classes.GridListTile}
                  >
                    <Paper
                      className={classes.paperBlock}
                      onClick={() => this.chooseTracker(tk)}
                    >
                      {activeTrackers.map(
                        atk =>
                          atk.id !== tk.id ? (
                            ''
                          ) : (
                            <div
                              key={`bookblockLayer-id${atk.id}`}
                              className={classes.bookBlockChecked}
                            />
                          )
                      )}
                      <div
                        key={`bookblock-key-${tk.id}`}
                        className={classes.bookBlock}
                      >
                        <img
                          alt=""
                          className={classes.iconBook}
                          src={process.env.PUBLIC_URL + tk.img}
                        />
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingLeft: 2,
                            paddingRight: 2,
                            textAlign: 'center',
                            fontSize: 12,
                            color: 'grey',
                            lineHeight: 1.1
                          }}
                        >
                          {tk.name}
                        </Typography>
                      </div>
                    </Paper>
                    <Typography
                      variant="caption"
                      id="bookDescription"
                      style={{
                        paddingLeft: 8,
                        paddingRight: 8,
                        fontSize: 9,
                        textAlign: 'left'
                      }}
                    >
                      {}
                    </Typography>
                  </GridListTile>
                ))}
              </GridList>
            </ListItem>

            <ListItem>
              <ListItemText />
              <Button color="inherit" onClick={this.handleClose}>
                <Typography
                  variant="body1"
                  style={{ fontSize: 18, color: 'grey' }}
                >
                  Continue
                </Typography>
              </Button>
            </ListItem>
            <ListItem className={classes.addSection} />
          </List>
        </Paper>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleCloseAddTrackerNo}
          style={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            overflow: 'scroll',
            height: '100%',
            backgroundColor: 'white'
          }}
        >
          <Paper
            style={{
              width: '100%',
              height: '100%',
              backgroundColor: 'white',
              textAlign: 'center'
            }}
          >
            <List>
              <ListItem divider>
                <ListItemIcon>
                  <IconButton
                    color="inherit"
                    onClick={this.handleCloseAddTrackerNo}
                    aria-label="Close"
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                </ListItemIcon>
                <ListItemText
                  className={classes.modalHealder}
                  primary={'Add New Tracker Information'}
                />
              </ListItem>
              <ListItem className={classes.modalContent}>
                <ListItemIcon>
                  <BookIcon className={classes.editIcons} />
                </ListItemIcon>
                <TextField
                  id="name"
                  label="Tracker Name"
                  className={classes.textField}
                  value={this.props.resultTrackers.tracker.name}
                  onChange={this.handleChange('name')}
                  margin="normal"
                />
              </ListItem>
              <ListItem className={classes.modalContentWhite}>
                <ListItemIcon>
                  <DescriptionIcon className={classes.editIcons} />
                </ListItemIcon>
                <TextField
                  id="description"
                  label="Tracker Description"
                  className={classes.textField}
                  value={this.props.resultTrackers.tracker.description}
                  onChange={this.handleChange('description')}
                  margin="normal"
                />
              </ListItem>
              <ListItem className={classes.modalContentDone}>
                <ListItemText />
                <Button color="inherit" onClick={this.handleCloseAddTrackerYes}>
                  <Typography
                    variant="body1"
                    style={{ fontSize: 18, color: 'grey' }}
                  >
                    Add
                  </Typography>
                </Button>
              </ListItem>
            </List>
          </Paper>
        </Modal>
      </div>
    )
  }
}

UserPreference.propTypes = {
  classes: PropTypes.object
}

UserPreference.defaultProps = {
  classes: {}
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/preference.js